import { useMedia } from 'react-media';

import breakpoints from '../utils/breakpoints';

// Returns true if the screen width matches the given size or smaller.
const useSmallScreen = (maxSize = 'sm') => {
  const size = maxSize in breakpoints ? maxSize : 'sm';
  return useMedia({ query: { maxWidth: breakpoints[size].max } });
};

export default useSmallScreen;
